import dayjs from '../../utils/dayjs';
import React, { useState } from 'react';
import { Badge, Button, ButtonGroup, Card, DataTable, EmptyState, Layout, Link, Page, Text } from '@shopify/polaris';
import { useGetVehicles, Vehicle, VehicleStatus } from 'queries/charge_station.query';
import emptyIMG from 'media/images/empty.png';

import SkeletonLoading from 'components/skeletonPageLoading';
import VehicleModal from './vehicle_modal';
import { useNavigate } from 'react-router-dom';

export default function VehicleList() {
  const { data: vehicleListData, isLoading, isSuccess } = useGetVehicles();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVehicleId, setCurrentVehicleId] = useState<number | null>(null);

  const vehicles = vehicleListData ?? [];
  const history = useNavigate();

  const handleOpenCreate = () => {
    setCurrentVehicleId(null);
    setIsModalOpen(true);
  };

  const handleOpenEdit = (vehicleId: number) => {
    setCurrentVehicleId(vehicleId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentVehicleId(null);
  };

  const renderStatusBadge = (status?: Vehicle['status']) => {
    switch (status) {
      case VehicleStatus.APPROVED:
        return <Badge tone="success">Đã duyệt</Badge>;
      case VehicleStatus.WHITELIST:
        return <Badge tone="info">Whitelist</Badge>;
      case VehicleStatus.BANNED:
        return <Badge tone="critical">Bị cấm</Badge>;
      case VehicleStatus.UNAPPROVED:
        return <Badge tone="warning">Chưa duyệt</Badge>;
      default:
        return <Badge tone="new">-</Badge>;
    }
  };

  const renderActions = (vehicle: Vehicle) => {
    if (!vehicle.id) {
      return (
        <Text as="span" tone="subdued">
          -
        </Text>
      );
    }

    return (
      <ButtonGroup>
        <Button size="slim" onClick={() => handleOpenEdit(vehicle.id)}>
          Chỉnh sửa
        </Button>
      </ButtonGroup>
    );
  };

  const rows = vehicles.map((vehicle) => [
    vehicle.id ?? '-',
    <Link
      onClick={() => {
        history(`/vehicle_management/view/${vehicle.id}`);
      }}
    >
      {vehicle.tagId ?? '-'}
    </Link>,
    vehicle.licensePlate ?? '-',
    vehicle.brand ?? '-',
    vehicle.vehicleType ?? '-',
    vehicle.manufactureYear ?? '-',
    renderStatusBadge(vehicle.status),
    vehicle.updatedAt ? dayjs(new Date(vehicle.updatedAt)).format('HH:mm:ss DD-MM-YYYY') : '-',
    renderActions(vehicle),
  ]);

  const emptyState = (
    <EmptyState heading="Không có xe nào!" image={emptyIMG}>
      <p>Chưa có dữ liệu xe. Hãy tạo mới hoặc thử lại sau.</p>
    </EmptyState>
  );

  if (isLoading) {
    return <SkeletonLoading />;
  }

  return (
    <Page
      title="Danh sách xe"
      primaryAction={{
        onAction: handleOpenCreate,
        content: 'Thêm xe',
      }}
    >
      <Layout>
        <Layout.Section>
          <Card padding="0">
            {isSuccess && vehicles.length > 0 ? (
              <DataTable
                hoverable
                fixedFirstColumns={2}
                columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text']}
                headings={['ID', 'Tag ID', 'Biển số', 'Hãng', 'Loại xe', 'Năm SX', 'Trạng thái', 'Cập nhật', 'Thao tác']}
                rows={rows}
                hideScrollIndicator
              />
            ) : (
              emptyState
            )}
          </Card>
        </Layout.Section>
      </Layout>
      <VehicleModal onClose={handleCloseModal} show={isModalOpen} currentVehicleId={currentVehicleId} />
    </Page>
  );
}

